export default __webpack_public_path__ + "static/celebi-07912d9a2dab8ad8e3bcc62b71611f2a.png";